// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"e2c78bb8","364":"a6858c9f","493":"04993de2","618":"09030c54","651":"0bc4b2f5","796":"6fa0b79b"}[chunkId] + ".chunk.js";
};